import RestService from '../services/rest';

async function getPlaces(limit, skip, search, order = '', field = '') {
  return RestService.getAuthenticated(
    `panel/places?limit=${limit}&skip=${skip}&search=${search}&order=${order}&field=${field}`,
  );
}

async function getPlace(id) {
  return RestService.getAuthenticated(`panel/places/${id}`);
}

async function createPlace(place) {
  return RestService.postAuthenticated('panel/places/create', place);
}

async function updatePlace(place) {
  return RestService.putAuthenticated('panel/places/update', place);
}

async function deletePlace(id) {
  return RestService.postAuthenticated('panel/places/delete', { id });
}

export default {
  getPlaces,
  getPlace,
  createPlace,
  updatePlace,
  deletePlace,
};
